import React from 'react'

export const ResourceBlogIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width='20'
    height='20'
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M17.5 6.66626C17.4997 6.37399 17.4225 6.08693 17.2763 5.83389C17.13 5.58086 16.9198 5.37073 16.6667 5.22459L10.8333 1.89126C10.58 1.74498 10.2926 1.66797 10 1.66797C9.70744 1.66797 9.42003 1.74498 9.16667 1.89126L3.33333 5.22459C3.08022 5.37073 2.86998 5.58086 2.72372 5.83389C2.57745 6.08693 2.5003 6.37399 2.5 6.66626V13.3329C2.5003 13.6252 2.57745 13.9122 2.72372 14.1653C2.86998 14.4183 3.08022 14.6285 3.33333 14.7746L9.16667 18.1079C9.42003 18.2542 9.70744 18.3312 10 18.3312C10.2926 18.3312 10.58 18.2542 10.8333 18.1079L16.6667 14.7746C16.9198 14.6285 17.13 14.4183 17.2763 14.1653C17.4225 13.9122 17.4997 13.6252 17.5 13.3329V6.66626Z'
      stroke='black'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M2.75 5.83203L10 9.9987L17.25 5.83203'
      stroke='black'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path d='M10 18.3333V10' stroke='black' strokeLinecap='round' strokeLinejoin='round' />
  </svg>
)

export const ResourceNewsIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width='20'
    height='20'
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M12.5026 15H8.33594'
      stroke='black'
      strokeWidth='0.833333'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M15.0026 11.668H8.33594'
      stroke='black'
      strokeWidth='0.833333'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M3.33073 18.3346H16.6641C17.1061 18.3346 17.53 18.159 17.8426 17.8465C18.1551 17.5339 18.3307 17.11 18.3307 16.668V3.33464C18.3307 2.89261 18.1551 2.46868 17.8426 2.15612C17.53 1.84356 17.1061 1.66797 16.6641 1.66797H6.66406C6.22203 1.66797 5.79811 1.84356 5.48555 2.15612C5.17299 2.46868 4.9974 2.89261 4.9974 3.33464V16.668C4.9974 17.11 4.8218 17.5339 4.50924 17.8465C4.19668 18.159 3.77276 18.3346 3.33073 18.3346ZM3.33073 18.3346C2.8887 18.3346 2.46478 18.159 2.15222 17.8465C1.83966 17.5339 1.66406 17.11 1.66406 16.668V9.16797C1.66406 8.72594 1.83966 8.30202 2.15222 7.98946C2.46478 7.6769 2.8887 7.5013 3.33073 7.5013H4.9974'
      stroke='black'
      strokeWidth='0.833333'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M14.1693 5H9.16927C8.70903 5 8.33594 5.3731 8.33594 5.83333V7.5C8.33594 7.96024 8.70903 8.33333 9.16927 8.33333H14.1693C14.6295 8.33333 15.0026 7.96024 15.0026 7.5V5.83333C15.0026 5.3731 14.6295 5 14.1693 5Z'
      stroke='black'
      strokeWidth='0.833333'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)

export const ResourceCustomerWorksIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width='20'
    height='20'
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M15.8333 2.5H4.16667C3.24619 2.5 2.5 3.24619 2.5 4.16667V15.8333C2.5 16.7538 3.24619 17.5 4.16667 17.5H15.8333C16.7538 17.5 17.5 16.7538 17.5 15.8333V4.16667C17.5 3.24619 16.7538 2.5 15.8333 2.5Z'
      stroke='black'
      strokeWidth='0.833333'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M7.5026 9.16536C8.42308 9.16536 9.16927 8.41917 9.16927 7.4987C9.16927 6.57822 8.42308 5.83203 7.5026 5.83203C6.58213 5.83203 5.83594 6.57822 5.83594 7.4987C5.83594 8.41917 6.58213 9.16536 7.5026 9.16536Z'
      stroke='black'
      strokeWidth='0.833333'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M17.5 12.5011L14.9283 9.92938C14.6158 9.61693 14.1919 9.44141 13.75 9.44141C13.3081 9.44141 12.8842 9.61693 12.5717 9.92938L5 17.501'
      stroke='black'
      strokeWidth='0.833333'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)

export const ResourceEducationDiscountIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width='20'
    height='20'
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M17.8464 9.10327C17.9956 9.03745 18.1222 8.92932 18.2105 8.79227C18.2989 8.65522 18.345 8.49526 18.3434 8.33221C18.3417 8.16917 18.2922 8.0102 18.201 7.875C18.1099 7.7398 17.9811 7.63431 17.8306 7.5716L10.6881 4.31827C10.4709 4.21922 10.2351 4.16797 9.99641 4.16797C9.75776 4.16797 9.52188 4.21922 9.30475 4.31827L2.16308 7.56827C2.01472 7.63324 1.88851 7.74005 1.79989 7.87561C1.71126 8.01118 1.66406 8.16963 1.66406 8.3316C1.66406 8.49357 1.71126 8.65202 1.79989 8.78759C1.88851 8.92315 2.01472 9.02996 2.16308 9.09493L9.30475 12.3516C9.52188 12.4506 9.75776 12.5019 9.99641 12.5019C10.2351 12.5019 10.4709 12.4506 10.6881 12.3516L17.8464 9.10327Z'
      stroke='black'
      strokeWidth='0.833333'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M18.3359 8.33203V13.332'
      stroke='black'
      strokeWidth='0.833333'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M5 10.418V13.3346C5 13.9977 5.52678 14.6336 6.46447 15.1024C7.40215 15.5712 8.67392 15.8346 10 15.8346C11.3261 15.8346 12.5979 15.5712 13.5355 15.1024C14.4732 14.6336 15 13.9977 15 13.3346V10.418'
      stroke='black'
      strokeWidth='0.833333'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)

export const ResourceReferralProgramIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width='20'
    height='20'
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M15 6.66797C16.3807 6.66797 17.5 5.54868 17.5 4.16797C17.5 2.78726 16.3807 1.66797 15 1.66797C13.6193 1.66797 12.5 2.78726 12.5 4.16797C12.5 5.54868 13.6193 6.66797 15 6.66797Z'
      stroke='black'
      strokeWidth='0.833333'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M5 12.5C6.38071 12.5 7.5 11.3807 7.5 10C7.5 8.61929 6.38071 7.5 5 7.5C3.61929 7.5 2.5 8.61929 2.5 10C2.5 11.3807 3.61929 12.5 5 12.5Z'
      stroke='black'
      strokeWidth='0.833333'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M15 18.332C16.3807 18.332 17.5 17.2127 17.5 15.832C17.5 14.4513 16.3807 13.332 15 13.332C13.6193 13.332 12.5 14.4513 12.5 15.832C12.5 17.2127 13.6193 18.332 15 18.332Z'
      stroke='black'
      strokeWidth='0.833333'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M7.15625 11.2578L12.8479 14.5745'
      stroke='black'
      strokeWidth='0.833333'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M12.8396 5.42578L7.15625 8.74245'
      stroke='black'
      strokeWidth='0.833333'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)

export const ResourceFreelancerSupportIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width='20'
    height='20'
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M10.0026 10.8333C12.3038 10.8333 14.1693 8.96785 14.1693 6.66667C14.1693 4.36548 12.3038 2.5 10.0026 2.5C7.70142 2.5 5.83594 4.36548 5.83594 6.66667C5.83594 8.96785 7.70142 10.8333 10.0026 10.8333Z'
      stroke='black'
      strokeWidth='0.833333'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M16.6693 17.4987C16.6693 15.7306 15.9669 14.0349 14.7166 12.7847C13.4664 11.5344 11.7707 10.832 10.0026 10.832C8.23449 10.832 6.5388 11.5344 5.28856 12.7847C4.03832 14.0349 3.33594 15.7306 3.33594 17.4987'
      stroke='black'
      strokeWidth='0.833333'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)

export const ResourceFGTCommunityIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width='20'
    height='20'
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M8.33594 12.2148V13.5698C8.33279 13.8554 8.25634 14.1353 8.11392 14.3828C7.9715 14.6303 7.76789 14.837 7.5226 14.9832C7.00189 15.3689 6.5783 15.8707 6.28551 16.4487C5.99271 17.0268 5.83878 17.6652 5.83594 18.3132'
      stroke='black'
      strokeWidth='0.833333'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M11.6641 12.2148V13.5698C11.6672 13.8554 11.7437 14.1353 11.8861 14.3828C12.0285 14.6303 12.2321 14.837 12.4774 14.9832C12.9981 15.3689 13.4217 15.8707 13.7145 16.4487C14.0073 17.0268 14.1612 17.6652 14.1641 18.3132'
      stroke='black'
      strokeWidth='0.833333'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M15 7.4987H16.25C16.8025 7.4987 17.3324 7.2792 17.7231 6.8885C18.1138 6.4978 18.3333 5.9679 18.3333 5.41536C18.3333 4.86283 18.1138 4.33293 17.7231 3.94223C17.3324 3.55152 16.8025 3.33203 16.25 3.33203H15'
      stroke='black'
      strokeWidth='0.833333'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M3.33594 18.332H16.6693'
      stroke='black'
      strokeWidth='0.833333'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M5 7.5013C5 8.82738 5.52678 10.0992 6.46447 11.0368C7.40215 11.9745 8.67392 12.5013 10 12.5013C11.3261 12.5013 12.5979 11.9745 13.5355 11.0368C14.4732 10.0992 15 8.82738 15 7.5013V2.5013C15 2.28029 14.9122 2.06833 14.7559 1.91205C14.5996 1.75577 14.3877 1.66797 14.1667 1.66797H5.83333C5.61232 1.66797 5.40036 1.75577 5.24408 1.91205C5.0878 2.06833 5 2.28029 5 2.5013V7.5013Z'
      stroke='black'
      strokeWidth='0.833333'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M4.9974 7.4987H3.7474C3.19486 7.4987 2.66496 7.2792 2.27426 6.8885C1.88356 6.4978 1.66406 5.9679 1.66406 5.41536C1.66406 4.86283 1.88356 4.33293 2.27426 3.94223C2.66496 3.55152 3.19486 3.33203 3.7474 3.33203H4.9974'
      stroke='black'
      strokeWidth='0.833333'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)

export const ResourceGetSponsoredIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width='20'
    height='20'
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M9.16406 14.1654L10.8307 15.832C10.9949 15.9962 11.1898 16.1264 11.4042 16.2152C11.6187 16.3041 11.8486 16.3498 12.0807 16.3498C12.3129 16.3498 12.5427 16.3041 12.7572 16.2152C12.9717 16.1264 13.1666 15.9962 13.3307 15.832C13.4949 15.6679 13.6251 15.473 13.7139 15.2585C13.8028 15.0441 13.8485 14.8142 13.8485 14.582C13.8485 14.3499 13.8028 14.12 13.7139 13.9055C13.6251 13.6911 13.4949 13.4962 13.3307 13.332'
      stroke='black'
      strokeWidth='0.833333'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M11.6688 11.6671L13.7521 13.7504C14.0837 14.0819 14.5333 14.2682 15.0021 14.2682C15.471 14.2682 15.9206 14.0819 16.2521 13.7504C16.5837 13.4189 16.7699 12.9693 16.7699 12.5004C16.7699 12.0316 16.5837 11.5819 16.2521 11.2504L13.0188 8.01709C12.5501 7.54892 11.9146 7.28595 11.2521 7.28595C10.5896 7.28595 9.95423 7.54892 9.48548 8.01709L8.75214 8.75042C8.42062 9.08194 7.97098 9.26819 7.50214 9.26819C7.0333 9.26819 6.58366 9.08194 6.25214 8.75042C5.92062 8.4189 5.73438 7.96926 5.73438 7.50042C5.73438 7.03158 5.92062 6.58194 6.25214 6.25042L8.59381 3.90875C9.35401 3.15054 10.3454 2.66755 11.411 2.53623C12.4766 2.40491 13.5556 2.63278 14.4771 3.18375L14.8688 3.41709C15.2236 3.63124 15.6455 3.70552 16.0521 3.62542L17.5021 3.33375'
      stroke='black'
      strokeWidth='0.833333'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M17.4974 2.5L18.3307 11.6667H16.6641'
      stroke='black'
      strokeWidth='0.833333'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M2.4974 2.5L1.66406 11.6667L7.08073 17.0833C7.41225 17.4149 7.86189 17.6011 8.33073 17.6011C8.79957 17.6011 9.24921 17.4149 9.58073 17.0833C9.91225 16.7518 10.0985 16.3022 10.0985 15.8333C10.0985 15.3645 9.91225 14.9149 9.58073 14.5833'
      stroke='black'
      strokeWidth='0.833333'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M2.5 3.33203H9.16667'
      stroke='black'
      strokeWidth='0.833333'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)
